module.exports = __webpack_public_path__ + "img/Cd.ce30675e.png";